/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import { DataTable } from '@scuf/datatable';
import './MeterSavingsTableTheme.scss';
import {
  IDataTableColumn,
  IMeterSavingsDetailTableProps
} from './IMeterSavingsDetailTableProps';
import { UtilityMeterField, UtilityType } from '../Utils/Constants';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import {
  cellDataRenderer,
  expanderTemplate,
  rowcellDataRenderer
} from './MeterSavingsDetailTableUtility';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';

const MeterSavingsDetailTable = (props: any) => {
  const { meterData, utilityCostCurrency, columnDetails, utilityType } = props;
  const sortedMeterData = () => {
    return meterData.map((mtr: IAny) => {
      return {
        ...mtr,
        utilityMeters:
          mtr?.utilityMeters.sort(
            (a: any, b: any) =>
              b.totalActualConsumption - a.totalActualConsumption
          ) || []
      };
    });
  };
  // const sortedmeterData = [
  //   {
  //     ...meterData[0],
  //     utilityMeters:
  //       meterData[0]?.utilityMeters.sort(
  //         (a: any, b: any) =>
  //           b.totalActualConsumption - a.totalActualConsumption
  //       ) || []
  //   }
  // ];
  const [fieldSortOrder, setFieldSortOrder] = useState<number>(-1);
  const [sortFieldName, setSortFieldName] = useState<string>(
    UtilityMeterField.totalActualConsumption
  );
  const [expandedRows, setexpandedRows] = useState([sortedMeterData()[0]]);

  const rowExpansionTemplate = (data: IAny) => {
    return (
      <div className="UtilityBill-row-expansion">
        <DataTable data={data.utilityMeters} showHeader={false}>
          <DataTable.Column initialWidth="1.5%" field="" header="" />
          {columnDetails.map((column: IDataTableColumn) => {
            return (
              <DataTable.Column
                key={column.field}
                className={column.className}
                field={column.field}
                header={column.header}
                sortable={column.sortable}
                renderer={(cellData) =>
                  rowcellDataRenderer(
                    cellData,
                    utilityCostCurrency,
                    utilityType
                  )
                }
                initialWidth={column.initialWidth}
              />
            );
          })}
        </DataTable>
      </div>
    );
  };

  let dataTableClass = 'Savingtable';
  if (utilityType === UtilityType.All)
    dataTableClass = 'nonflat-table Savingtable';

  return (
    <div className="Savings-Datatable">
      <DataTable
        data={sortedMeterData()}
        scrollable={true}
        scrollHeight="20rem"
        className={dataTableClass}
        expandedRows={expandedRows}
        rowExpansionTemplate={rowExpansionTemplate}
        sortField={sortFieldName}
        sortOrder={fieldSortOrder}
        onSort={({ sortField, sortOrder }) => {
          setFieldSortOrder(sortOrder as number);
          setSortFieldName(sortField);
        }}
      >
        <DataTable.Column
          field=""
          header=""
          initialWidth="1.5%"
          renderer={(data: ICellData) =>
            expanderTemplate(data, expandedRows, setexpandedRows)
          }
        />
        {columnDetails.map((column: IDataTableColumn) => {
          return (
            <DataTable.Column
              className={column.className}
              key={column.field}
              field={column.field}
              header={column.header}
              sortable={column.sortable}
              renderer={(cellData) =>
                cellDataRenderer(cellData, utilityCostCurrency)
              }
              initialWidth={column.initialWidth}
            />
          );
        })}
      </DataTable>
    </div>
  );
};
export default MeterSavingsDetailTable;
